<template>
    <ShowControl  @revert="revertClick"  :title="title" ref="showControl" :knowledgeType="Global.KnowledgeTypeList.filter(c=>c.name == '现场跟踪及营销')[0].value">
  <div  style="margin-top: 3%;width: 80%;">
    <el-table :data="
        SceneTrackList
      "
              style="width: 100%;height: 85%;"

              empty-text="暂无数据"
              v-loading="loding">
              <el-table-column prop="name"
                       label="名称"
                       align="center">
      </el-table-column>
      <el-table-column prop="type"
                       label="类型"
                       align="center">
      </el-table-column>
      <el-table-column label="操作"
                       align="center"
                       fixed="right"
                       width="200px">
        <template #default="scope">
          <div>
            <el-button size="large"
                     type="primary" v-if="SceneTrackSModelList.filter(c=>c.uuid==scope.row.uuid&&c.state!=Global.SModel.Delete).length == 0"
                     @click="trackClick(scope.$index, scope.row)">
                     {{SceneTrackSModelList.filter(c=>c.uuid==scope.row.uuid&&c.state!=Global.SModel.Delete).length>0?"取消":"跟踪"}}
                    </el-button>      
          </div>
        </template>
      </el-table-column>
    </el-table>
    <el-pagination @size-change="handleSizeChange"
                   @current-change="handleCurrentChange"
                   :current-page="currentPage"
                   :page-sizes="[5, 10, 15, 20]"
                   :page-size="pagesize"
                   layout="total, sizes, prev, pager, next, jumper"
                   :total="SceneTrackTotal"
                   style="display: flex; justify-content: center; margin-top: 10px">
    </el-pagination>
  </div>
</ShowControl>
</template>
<script>
import { mapState } from "vuex";
import ShowControl from "../../UserControl/ShowControl.vue"
export default {
  props: ["department"],
  data () {
    return {
      loding: false,
      caseID: localStorage.getItem("caseId"),
      flowID: localStorage.getItem("flowID"),
      currentPage: 1,
      pagesize: 5,
      SceneTrackList:[],
      SceneTrackSModelList:[],
      SceneTrackTotal:0,
      title: '现场跟踪及营销',
    };
  },
  components: {ShowControl},
  computed: {
    ...mapState({
      Round: (state) => state.user.round,
      ChatShow:(state) => state.user.chatShows,
    }),
  },
  created () {
    this.GetSceneTrackInfo();
    this.GetAllSceneTrackSModel();
  },
  mounted () {
    this.$refs.showControl.receiveValue(true);
  },
  methods: {
    revertClick(){
      this.$router.push("/MiceMarketing")
    },
    handleSizeChange: function (size) {
      this.pagesize = size;
      this.GetSceneTrackInfo();
    },
    //当前页码
    handleCurrentChange: function (currentPage) {
      this.currentPage = currentPage;
      this.GetSceneTrackInfo();
    },
    GetSceneTrackInfo()
    {
      this.loding = true
      this.$http.get(
          "SceneTrack/GetAllSceneTrack?round=" +
          this.Round+"&pageNumber="+this.currentPage+"&pageSize="+this.pagesize
        ).then((res)=>{
        if(res.success){
            this.SceneTrackList=res.dynamicObj
            this.SceneTrackTotal = res.totalRecord;
            this.loding = false;
        }
      })
    },
    GetAllSceneTrackSModel()
      {
        this.$http.get('SModel/GetTypeSModel?round='+this.Round+"&typename=S_SceneTrack").then((res)=>{
          if(res.success){
              this.SceneTrackSModelList=res.dynamicObj
          }
        })
      },
    trackClick (index, row) {
      if(this.flowID != this.Global.FlowList.执行)
        {
          this.$message.error("当前流程阶段不是执行，无法进行操作！");
          return;
        }
        if(this.SceneTrackSModelList.filter(c=>c.uuid==row.uuid&&c.state!=this.Global.SModel.Delete).length>0)
        {
            let list=this.SceneTrackSModelList.filter(c=>c.uuid==row.uuid)
            list[0].state=this.Global.SModel.Delete;
            list[0].sceneState = this.Global.SceneState.NotTracked
            this.$http
              .post("SModel/PushStrategy", this.Global.getsmodel(list))
              .then((res) => {
                if (res.success) {
                  this.Global.sendmsgmd(
                      "会展营销",
                      `取消取消跟踪了`+row.name,
                      1
                    );
                  this.GetAllSceneTrackSModel();
                  this.API.createTaskBar(this.Round,this.Global.EnumUserStatus.delete,'现场跟踪及营销');
                } else {
                  this.$message.error(res.message);
                  return false;
                }
              });
        }else
        {
          let list=this.SceneTrackSModelList.filter(c=>c.uuid==row.uuid);
          if(list.length==0)
          {
            list=[{
              round: parseInt(this.Round),
              type:"S_SceneTrack",
              uuid: row.uuid,
              sTTime: this.filter.formatDate(new Date()),
              state: this.Global.SModel.Create,
              sceneState: this.Global.SceneState.Tracked
            }];    
          }else
          {
              list[0].state=this.Global.SModel.Update;
              list[0].sTTime= this.filter.formatDate(new Date());
          }  
          this.$http
              .post("SModel/PushStrategy", this.Global.getsmodel(list))
              .then((res) => {
                if (res.success) {
                  this.Global.sendmsgmd(
                      "会展营销",
                      `对`+row.name+"现场跟踪并营销",
                      1
                    );
                  this.GetAllSceneTrackSModel();
                  this.$store.commit("chatShow",{ isOperate : !this.ChatShow, chatValue: this.Global.OperateType.现场跟踪及营销 });  
                  this.API.createTaskBar(this.Round,this.Global.EnumUserStatus.normal,'现场跟踪及营销');
                } else {
                  this.$message.error(res.message);
                  return false;
                }
              });
        }
        
        },
  },
};
</script>

<style scoped>
.span {
  font-size: 24px;
  color: blue;
}

.indexItem {
  display: flex;
  justify-content: space-between;
  text-align: center;
  padding-left: 70px;
}

.time {
  font-size: 12px;
  color: #999;
}

.bottom {
  margin-top: 13px;
  line-height: 12px;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.button {
  padding: 0;
  min-height: auto;
}
.table {
  width: 100%;
}
.table > tr {
  width: 30%;
}
.table > tr > td {
  width: 30%;
}
.image {
  width: 100%;
  height: 100px;
  display: block;
}

.imgbox {
  width: 90px;
  height: 90px;
  border-radius: 50%;
  margin: 0 auto;
}
.font {
  font-size: 1.1em;
  color: black;
}
.radius {
  margin: 1px 0;
  background-color: #00adef;
  border-radius: 50%;
  width: 20px;
  height: 20px;
}
</style>